import enrollCmd from "../base/enrollCmd";
import bioFinger from "../base/bioFinger";
import bioEnrollDeviceType from "../base/bioEnrollDeviceType";

/**
 * Nothing to fancy here, just checks input values and builds the JSON to send to plugin manager
 * @param finger 
 */
export const enrollLumidigmM211Msg = (finger?) => {
    const fingerSelected = finger ? finger : bioFinger.UNKNOWN_FINGER;
    const enrolMessage = "{'enrollType':'" + enrollCmd.CMD_LUMIDIGM + "',finger':'" + fingerSelected + "','enrollForDeviceType':'" + bioEnrollDeviceType.SINGLE + "'}";
    return enrolMessage;
};

/**
  * converts the message to object type.
  * @param {*} obj
  */
export const decodeLumidigmPluginMsg = (obj) => {
    // TODO
};